import { CONSTANTS } from "@/config/constants";

export type AppTheme = "dark" | "light";

const CLINICPILOT_VARIANTS = {
  dark: "/clinicpilot-animated-gradient-dark-bg.json",
  light: "/clinicpilot-animated-gradient-light-bg.json",
};
const REPLYN_VARIANTS = {
  dark: "/replyn-hero-dark-4s.json",
  light: "/replyn-hero-light-4s.json",
};
const TENANT_LOTTIE_PATHS: Record<string, Partial<Record<AppTheme, string>>> = {
  replyn: CONSTANTS.IS_PRODUCTION ? REPLYN_VARIANTS : CLINICPILOT_VARIANTS,
  clinicpilot: CLINICPILOT_VARIANTS,
};

export const getTenantLottiePath = (
  slug: string,
  theme: AppTheme,
): string | null => TENANT_LOTTIE_PATHS[slug]?.[theme] ?? null;

const promiseCache = new Map<string, Promise<unknown>>();
const dataCache = new Map<string, unknown>();
const frameCache = new Map<string, number>();

export const getCachedLottieData = (path: string): unknown | null => {
  return dataCache.get(path) ?? null;
};

export const getCachedLottieFrame = (path: string): number => {
  return frameCache.get(path) ?? 0;
};

export const setCachedLottieFrame = (path: string, frame: number): void => {
  frameCache.set(path, frame);
};

export const getLottieData = (path: string): Promise<unknown> => {
  const cached = promiseCache.get(path);

  if (cached) return cached;

  const promise = fetch(path)
    .then((res) => {
      if (!res.ok) throw new Error(`Failed to load ${path}: ${res.status}`);

      return res.json();
    })
    .then((data) => {
      dataCache.set(path, data);

      return data;
    });

  promiseCache.set(path, promise);

  return promise;
};
